import { axios } from '@/utils/request'

const api = {
  shopAdd: '/badminapi/businessshop/shopAdd',
  shopEdit: '/badminapi/businessshop/shopEdit',
  shopDelete: '/badminapi/businessshop/shopDelete',
  shopDetail: '/badminapi/businessshop/shopDetail',
  shopList: '/badminapi/businessshop/shopList',
  shopRankEdit: '/badminapi/businessshop/shopRankEdit',
  shopUserList: '/badminapi/businessshop/shopUserList',
  addShopUser: '/badminapi/businessshop/addShopUser',
  deleteShopUser: '/badminapi/businessshop/deleteShopUser',
}

export default api

export function getShopUserList(parameter) {
  return axios({
    url: api.shopUserList,
    method: 'get',
    params: parameter
  })
}
export function getShopList(parameter) {
  return axios({
    url: api.shopList,
    method: 'get',
    params: parameter
  })
}
export function getShopDetail(parameter) {
  return axios({
    url: api.shopDetail,
    method: 'get',
    params: parameter
  })
}
export function addShop(parameter) {
  return axios({
    url: api.shopAdd,
    method: 'post',
    data: parameter
  })
}
export function editShop(parameter) {
  return axios({
    url: api.shopEdit,
    method: 'post',
    data: parameter
  })
}
export function deleteShop(parameter) {
  return axios({
    url: api.shopDelete,
    method: 'post',
    data: parameter
  })
}
export function setShopRank(parameter) {
  return axios({
    url: api.shopRankEdit,
    method: 'post',
    data: parameter
  })
}

export function addShopUser(parameter) {
  return axios({
    url: api.addShopUser,
    method: 'post',
    data: parameter
  })
}
export function deleteShopUser(parameter) {
  return axios({
    url: api.deleteShopUser,
    method: 'post',
    data: parameter
  })
}